import styled from '@emotion/styled'
import { FieldError, useFormContext } from 'react-hook-form'

import { PaddingInset } from '@cash-design-system/react'

export type FieldErrorProps = {
  name: string
  id?: string
}

export const ErrorText = styled.div`
  color: ${props => props.theme.colors.error};
  ${({ theme }) => theme.typography.helpText};
  margin-top: ${({ theme }) => theme.spacing.xs};
  word-break: break-word;
`
export const FieldErrorText = ({ name, id }: FieldErrorProps) => {
  const {
    formState: { errors, isSubmitted },
  } = useFormContext()
  // traverse object to get error message
  const error = name.split('.').reduce((acc, key) => {
    return acc?.[key]
  }, errors) as FieldError

  // only show required errors if form has been submitted
  const showError = isSubmitted || error?.type !== 'required'

  if (error?.message && showError) {
    return (
      <PaddingInset>
        <ErrorText id={id}>{error.message}</ErrorText>
      </PaddingInset>
    )
  }

  return null
}
